<div>

  <mat-tab-group>
    <mat-tab label="Slider">
      <div class="headings-sliders">
        <mat-form-field class="pe-se-input">
          <mat-label>Slider Heading</mat-label>
          <input matInput
                 [(ngModel)]="item.data.Heading">

        </mat-form-field>
        <mat-form-field class="pe-se-input">
          <mat-label>Slider Sub Heading</mat-label>
          <textarea matInput
                    [(ngModel)]="item.data.SubHeading">
          </textarea>
        </mat-form-field>
      </div>
      <small class="text-muted" style="padding-left:5px;">16:6 preferred image size ratio </small>

      <div class='pe-se-input pe-se-file' *ngFor="let slider of item.data.images;index as indexSlider">
        <span class="fa fa-times pe-se-remove" (click)="removeSlider(indexSlider)"></span>
        <input type='file' (change)="selectFileToSlider($event,indexSlider)" accept="image/*">
        <img alt="background Image" [attr.src]="imageSelector(slider.image)" />
      </div>
      <div class='pe-se-input pe-se-file'>
        <input type='file' (change)="selectFileToSlider($event,-1)" accept="image/*">
        <img alt="background Image" [attr.src]="imageSelector('')" />
      </div>


    </mat-tab>

    <mat-form-field class="pe-se-input">
      <mat-label>Description</mat-label>
      <input matInput
             [(ngModel)]="item.data.description">

    </mat-form-field>


    <mat-tab label="Layout">
      <app-sub-layout-setting [item]="item" [layoutSetting]="layoutSetting"></app-sub-layout-setting>
    </mat-tab>
  </mat-tab-group>

</div>
